import { useState } from "react";
import { SearchNormal1, Briefcase } from "iconsax-react";
import cn from "classnames";
import { Input } from "@/shared/ui";

export type RedistributeItemId = number | "external_pool";

export interface RedistributeListItem {
  id: RedistributeItemId;
  name: string;
  meta: string;
  amount: string;
}

interface Props {
  items: RedistributeListItem[];
  selectedId: RedistributeItemId | null;
  onSelect: (id: RedistributeItemId) => void;
  amountCaption: string;
  searchPlaceholder: string;
  emptyText: string;
}

export default function RedistributeProjectList({
  items,
  selectedId,
  onSelect,
  amountCaption,
  searchPlaceholder,
  emptyText,
}: Props) {
  const [query, setQuery] = useState("");
  const filtered = items.filter((item) => item.name.toLowerCase().includes(query.trim().toLowerCase()));

  return (
    <div className="flex flex-col gap-3">
      <Input
        placeholder={searchPlaceholder}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        icon={<SearchNormal1 size={18} color="currentColor" />}
      />

      {filtered.length === 0 ? (
        <p className="text-body-regular-sm content-base-secondary py-6 text-center">{emptyText}</p>
      ) : (
        <div className="flex flex-col gap-2 max-h-[420px] overflow-auto page-scroll pr-1">
          {filtered.map((item) => {
            const isSelected = item.id === selectedId;
            return (
              <button
                key={String(item.id)}
                type="button"
                onClick={() => onSelect(item.id)}
                className={cn(
                  "flex items-center gap-3 p-3 radius-md border text-left cursor-pointer transition-colors",
                  isSelected ? "surface-brand-subtle surface-brand-stroke" : "surface-base-stroke hover:surface-secondary-fill",
                )}>
                <div className="w-9 h-9 radius-xs flex items-center justify-center shrink-0 surface-component-fill content-action-brand">
                  <Briefcase size={18} color="currentColor" />
                </div>
                <div className="flex flex-col min-w-0 flex-1">
                  <span
                    className={cn(
                      "text-body-bold-sm truncate",
                      isSelected ? "content-action-brand" : "content-base-primary",
                    )}>
                    {item.name}
                  </span>
                  <span className="text-body-regular-xs content-base-secondary truncate">{item.meta}</span>
                </div>
                <div className="flex flex-col items-end shrink-0">
                  <span className="text-body-regular-xs content-base-secondary">{amountCaption}</span>
                  <span className="text-body-bold-sm content-base-primary">{item.amount}</span>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
